export default __webpack_public_path__ + "static/media/4-color.e803c819.svg";